<template>
  <CRow>
    <CCol col="12" xl="12">
      <Spinner v-if="$store.state.loadSpinner" />

      <CCard v-else>
        <CCardHeader>
          <span>المقالات </span>

          <!-- <CButton
            class="float-right"
            color="info"
            @click="
              $router.push({
                name: `Create Article`,
              })
            "
          >
            <CIcon name="cil-plus"></CIcon>
            <span> اضافة مقال </span>
          </CButton> -->
        </CCardHeader>
        <CCardBody>
          <div class="table-responsive">
            <table class="table table-striped table-bordered table-hover mb-5">
              <thead>
                <tr class="table-primary">
                  <th scope="col">#</th>
                  <th scope="col">التصنيف</th>
                  <th scope="col">عنوان المقالة</th>
                  <th scope="col">المحامي</th>
                  <th scope="col">الحالة</th>
                  <th scope="col">الصورة</th>
                  <th scope="col">الاجراءات</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <th scope="row">{{ item.id }}</th>
                  <td>{{ item.category }}</td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.lawyer }}</td>
                  <td>
                    <b v-if="(item.status == 1)" :class="`text-${getBadge(item.status)}`">
                      جديد
                    </b>
                    <b v-else-if="(item.status == 2)" :class="`text-${getBadge(item.status)}`">
                      نشط
                    </b>
                    <b v-else :class="`text-${getBadge(item.status)}`">
                      متوقف
                    </b>
                  </td>
                  <td>
                    <CImg
                      height="60px"
                      width="60px"
                      :src="item.image_url"
                      fluid
                    />
                  </td>
                  <td>
                    <CButton
                      color="info"
                      @click="
                        $router.push({
                          name: 'Article',
                          params: {
                            id: item.id,
                          },
                        })
                      "
                    >
                      <CIcon name="cil-low-vision"></CIcon>
                    </CButton>
                    <CButton
                      class="mx-1"
                      color="warning"
                      @click="openModal(item)"
                    >
                      <CIcon name="cil-pencil"></CIcon>
                    </CButton>
                    <CButton
                      class="mx-1"
                      color="danger"
                      @click="deleteItem(item.id)"
                    >
                      <CIcon name="cil-trash"></CIcon>
                    </CButton>
                    <CButton v-if="item.status == 1" class="mx-2" color="success" @click="updateStatus(2, item.id)">
                      تفعيل
                    </CButton>
                    <CButton v-else-if="item.status == 3 || item.status == 3" class="mx-2" color="success" @click="updateStatus(2, item.id)">
                      تفعيل
                    </CButton>
                    <CButton v-else color="danger" class="mx-2" @click="updateStatus(3, item.id)">
                      ايقاف
                    </CButton>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <CPagination :active-page.sync="currentPage" :pages="totalPages" />
        </CCardBody>
      </CCard>
    </CCol>
    <edit :form="modalForm" @updateDone="updateDone"></edit>
  </CRow>
</template>

<script>
import Edit from "./Edit";
export default {
  name: "Articles",
  components: {
    Edit,
  },
  data() {
    return {
      items: [],
      activePage: 1,
      currentPage: 1,
      totalPages: 0,
      limit: 10,
      modalForm: null,
    };
  },
  watch: {
    currentPage: {
      handler: function (val, oldVal) {
        this.fetchData(val);
      },
      deep: true,
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData(page = 1) {
      this.toggleLoadSpinner();

      this.$http
        .get(`/articles?per_page=15&page=${page}`)
        .then((res) => {
          // handle success
          this.items = res.data.data.data;
          this.totalPages = res.data.data.last_page;
          this.toggleLoadSpinner();
        })
        .catch((error) => {
          //
          this.toggleLoadSpinner();
        });
    },

    toggleLoadSpinner() {
      this.$store.commit("toggleLoadSpinner");
    },

    deactivate(itemId) {
      console.log(itemId);
    },

    getBadge(status) {
      switch (status) {
        case 2:
          return "success";
        case 3:
          return "danger";
        default:
          return "primary";
      }
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },
    openModal(item) {
      this.modalForm = Object.assign({}, item);
      this.update = true;
      this.$store.commit("set", ["showModal", true]);
    },
    deleteItem(id) {
      this.$swal
        .fire({
          title: "تأكيد الحذف",
          text: "هل انت متأكد من الحذف ؟",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "نعم",
          cancelButtonText: "لا",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.$http
              .delete("articles/" + id)
              .then((res) => {
                // handle success
                if (res.data.status == 200) {
                  this.fetchData();
                  this.$swal.fire("تم الحذف!", "تم الحذف بنجاح.", "success");
                }
              })
              .catch((error) => {
                // handle error
                console.log(error);
              });
          }
        });
    },
    updateDone() {
      this.fetchData();
    },

    updateStatus(status, id) {
      console.log(status, id);
      this.toggleLoadSpinner();

      this.$http
        .put(`/articles/status/${id}`, { status })
        .then((res) => {
          console.log(res.data);
          const index = this.items.findIndex(object => {
            return object.id === id;
          });
          this.fetchData();
          // Vue.set(this.items, index, res.data.data);
          this.toggleLoadSpinner();
        })
        .catch((error) => {
          // handle error
          this.toggleLoadSpinner();
        });
    }
  },
};
</script>